import { Reply } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { fillSupportTemplate } from '@/lib/support';

interface SupportWaitingBannerProps {
  count: number;
  onShow: () => void;
}

/**
 * Banner shown on the Support page while support is waiting on the customer's reply to one or more
 * tickets. It is the one place the page asks the customer to act, so it uses the strong amber.
 */
export function SupportWaitingBanner({ count, onShow }: SupportWaitingBannerProps) {
  const { t } = useLanguage();
  if (count <= 0) return null;

  const title =
    count === 1
      ? t.support.waitingBanner.titleOne
      : fillSupportTemplate(t.support.waitingBanner.titleOther, { count });

  return (
    <div role="status" className="flex items-center gap-3 rounded-lg border border-warning background-warning px-4 py-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full background-warning-strong text-warning-strong">
        <Reply className="h-4 w-4" aria-hidden />
      </div>
      <div className="flex-1 text-sm">
        <div className="font-semibold">{title}</div>
        <div>{t.support.waitingBanner.body}</div>
      </div>
      <Button variant="outline" size="sm" onClick={onShow}>
        {t.support.waitingBanner.action}
      </Button>
    </div>
  );
}
